import { App as FG_Setpoint } from './FG_Setpoint/appDeclaration';
import { App as FG_AirHandlingUnitSetpoint } from './FG_AirHandlingUnitSetpoint/appDeclaration';
import { App as FG_HeatingSetpoint } from './FG_HeatingSetpoint/appDeclaration';
import { App as FG_CoolingSetpoint } from './FG_CoolingSetpoint/appDeclaration';
import { App as FG_Control } from './FG_Control/appDeclaration';
import { App as FG_AirHandlingUnitTemperatureControl } from './FG_AirHandlingUnitTemperatureControl/appDeclaration';
import { App as FG_AirHandlingUnitHumidityControl } from './FG_AirHandlingUnitHumidityControl/appDeclaration';
import { App as FG_AirHandlingUnitPressureControl,
     AppExhaust as FG_AirHandlingUnitPressureControlExhaust,
     AppSupply as FG_AirHandlingUnitPressureControlSupply
 } from './FG_AirHandlingUnitPressureControl/appDeclaration';
import { App as FG_HeatingControl } from './FG_HeatingControl/appDeclaration';
import { App as FG_CoolingControl } from './FG_CoolingControl/appDeclaration';
import { App as FG_SAUTER_HeatingSetpoint } from './FG_SAUTER_HeatingSetpoint/appDeclaration';
import { App as FG_SAUTER_CoolingSetpoint } from './FG_SAUTER_CoolingSetpoint/appDeclaration';

export const Apps = {
    [FG_AirHandlingUnitSetpoint.schema]: FG_AirHandlingUnitSetpoint,
    [FG_AirHandlingUnitTemperatureControl.schema]: FG_AirHandlingUnitTemperatureControl,
    [FG_AirHandlingUnitHumidityControl.schema]: FG_AirHandlingUnitHumidityControl,
    [FG_AirHandlingUnitPressureControl.schema]: FG_AirHandlingUnitPressureControl,
    [FG_AirHandlingUnitPressureControlExhaust.schema]: FG_AirHandlingUnitPressureControlExhaust,
    [FG_AirHandlingUnitPressureControlSupply.schema]: FG_AirHandlingUnitPressureControlSupply,
    [FG_Setpoint.schema]: FG_Setpoint,
    [FG_HeatingSetpoint.schema]: FG_HeatingSetpoint,
    [FG_CoolingSetpoint.schema]: FG_CoolingSetpoint,
    [FG_Control.schema]: FG_Control,
    [FG_HeatingControl.schema]: FG_HeatingControl,
    [FG_CoolingControl.schema]: FG_CoolingControl,
    [FG_SAUTER_HeatingSetpoint.schema]: FG_SAUTER_HeatingSetpoint,
    [FG_SAUTER_CoolingSetpoint.schema]: FG_SAUTER_CoolingSetpoint,
}